import React from 'react';
import { StyleSheet, Text, View, Modal, TouchableOpacity } from 'react-native';
import Colours from '../utils/Colours';
import CrossIcon from '../icons/CrossIcon';
import CheckMarkIcon from '../icons/CheckMarkIcon';

const SuccessAlertComp = ({ message, onClose }) => {
    return (

        <View style={styles.modalOverlay}>
            <View style={styles.modalContainer}>
                <CheckMarkIcon height={40} width={40} color={Colours.LIGHTGREEN} />
                {/* <CrossIcon height={40} width={40} color={'red'} /> */}
                <Text style={styles.successTitle}>Success!</Text>
                <Text style={styles.successMessage}>{message}</Text>
                <TouchableOpacity style={styles.closeButton} onPress={onClose}>
                    <Text style={styles.closeButtonText}>Ok</Text>
                </TouchableOpacity>
            </View>
        </View>
    );
};

export default SuccessAlertComp;

const styles = StyleSheet.create({
    modalOverlay: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    modalContainer: {
        width: '80%',
        padding: 20,
        backgroundColor: 'white',
        borderRadius: 10,
        alignItems: 'center',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
    },
    successTitle: {
        fontSize: 20,
        fontWeight: 'bold',
        color: Colours.PRIMARY,
        marginBottom: 10,
        fontFamily: 'Sen-Regular',

    },
    successMessage: {
        fontSize: 16,
        color: '#333',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 20,
        marginTop: 10,
        fontFamily: 'Sen-Regular',
    },
    closeButton: {
        backgroundColor: Colours.PRIMARY,
        paddingVertical: 10,
        paddingHorizontal: 20,
        borderRadius: 10,
    },
    closeButtonText: {
        color: 'white',
        fontWeight: 'bold',
        fontSize: 15,
        fontFamily: 'Sen-Regular'

    },
});
